"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, /**
 * Primary UI component for user interaction
 */ "default", {
    enumerable: true,
    get: function() {
        return Button;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _react = /*#__PURE__*/ _interop_require_default(require("react"));
var _core = require("@mantine/core");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Button(_param) {
    var handleClick = _param.handleClick, icon = _param.icon, _param_spacing = _param.spacing, spacing = _param_spacing === void 0 ? "0px" : _param_spacing, _param_align = _param.align, align = _param_align === void 0 ? "left" : _param_align, props = _object_without_properties_loose(_param, [
        "handleClick",
        "icon",
        "spacing",
        "align"
    ]);
    return /*#__PURE__*/ (0, _jsxruntime.jsx)("div", {
        style: {
            padding: spacing,
            textAlign: align
        },
        children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Button, _extends({}, props, {
            leftSection: icon && icon,
            onClick: handleClick
        }))
    });
}
